export const communityUrl = 'https://vk.ru/strategix_ad';
export const communityName = 'Сообщество STRATEGIX';

export const ownerVkUrl = 'https://vk.ru/ad_strategix_marsel';
export const ownerName = 'Владелец STRATEGIX';
export const companyInn = '165916429782';
export const companyOgrnip = '318169000008600';

export const navLinks = [
  { label: 'О нас', href: '/about' },
  { label: 'Гарантии', href: '/guarantees' },
  { label: 'Команда', href: '/team' },
  { label: 'Отзывы', href: '/reviews' },
  { label: 'Кейсы', href: '/cases' },
  { label: 'Результаты', href: '/results' },
  { label: 'Тарифы', href: '/pricing' },
];

export const sectionsOverview = [
  { icon: 'ri-information-line', title: 'О нас', path: '/about', text: 'Кто мы, как устроена работа и почему мы продвигаем сообщества, сайты и каналы.' },
  { icon: 'ri-shield-check-line', title: 'Гарантии', path: '/guarantees', text: 'Договор, прозрачная отчётность и возврат остатка рекламного бюджета.' },
  { icon: 'ri-team-line', title: 'Команда', path: '/team', text: 'Специалисты по таргету, аналитике и контенту, которые ведут ваше сообщество.' },
  { icon: 'ri-star-line', title: 'Отзывы', path: '/reviews', text: 'Результаты клиентов в цифрах: рост подписчиков, охватов и заявок.' },
  { icon: 'ri-briefcase-line', title: 'Кейсы', path: '/cases', text: 'Реальные проекты в цифрах: задачи, решения и метрики роста по нишам.' },
  { icon: 'ri-trophy-line', title: 'Результаты', path: '/results', text: 'Итоговые цифры: рост подписчиков, заявок и охватов на каждой площадке.' },
  { icon: 'ri-price-tag-3-line', title: 'Тарифы', path: '/pricing', text: 'Понятные тарифы без скрытых платежей — от старта до крупных проектов.' },
];

export const heroStats = [
  { value: 240, suffix: '+', label: 'сообществ продвинули' },
  { value: 12, suffix: ' млн', label: 'подписчиков привлекли' },
  { value: 7, suffix: ' лет', label: 'в продвижении' },
  { value: 96, suffix: '%', label: 'клиентов продлевают' },
];

export const marqueeItems = [
  'Таргетированная реклама',
  'Рост подписчиков',
  'Контент-стратегия',
  'Работа с охватами',
  'Вовлечение аудитории',
  'Аналитика и отчётность',
  'Рассылки в сообществах',
  'Упаковка паблика',
];

export const guarantees = [
  {
    icon: 'ri-shield-check-line',
    title: 'Договор или гарантийное письмо',
    text: 'Заключаем официальный договор либо гарантийное письмо — на выбор. Все обязательства и KPI фиксируем документально.',
    accent: true,
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Прозрачная отчётность',
    text: 'Каждую неделю — отчёт по охватам, подпискам и заявкам.',
    accent: false,
  },
  {
    icon: 'ri-refund-2-line',
    title: 'Возврат остатка бюджета',
    text: 'Если не израсходовали рекламный бюджет — возвращаем остаток без споров и удержаний.',
    accent: false,
  },
  {
    icon: 'ri-lock-2-line',
    title: 'Доступы только у вас',
    text: 'Никогда не забираем права администратора. Все доступы остаются у владельца сообщества.',
    accent: false,
  },
  {
    icon: 'ri-user-star-line',
    title: 'Персональный стратег',
    text: 'За проектом закрепляется один специалист, который ведёт вас от старта до результата.',
    accent: false,
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Запуск за 3 дня',
    text: 'Анализ аудитории, упаковка и первые рекламные кампании стартуют в течение трёх рабочих дней.',
    accent: true,
  },
];

export const guaranteesFaq = [
  {
    question: 'Что именно вы гарантируете?',
    answer: 'В договоре мы фиксируем измеримые KPI — подписчики, охват и стоимость заявки. Вы заранее понимаете, на какой результат можно рассчитывать при выбранном бюджете, а не получаете обещание «на удачу».',
  },
  {
    question: 'Что будет, если результат не достигнут?',
    answer: 'Разберём, что пошло не так, бесплатно скорректируем кампании и продолжим работу до достижения показателей. Если рекламный бюджет не израсходован — вернём остаток без споров и удержаний.',
  },
  {
    question: 'Как происходит возврат остатка бюджета?',
    answer: 'Рекламный бюджет вы пополняете напрямую в рекламном кабинете. Всё, что не израсходовано, остаётся у вас или возвращается — поэтому никаких «зависших» денег и скрытых комиссий.',
  },
  {
    question: 'Кому принадлежат доступы к сообществу?',
    answer: 'Все доступы остаются у вас. Мы работаем через ваши рекламные кабинеты и никогда не забираем права администратора — вы в любой момент можете контролировать происходящее.',
  },
  {
    question: 'Как часто приходит отчётность?',
    answer: 'Каждую неделю — отчёт по охватам, подпискам и заявкам. Плюс ежемесячный сводный отчёт, чтобы видеть динамику и результаты в целом.',
  },
  {
    question: 'Можно ли расторгнуть договор досрочно?',
    answer: 'Да, в любой момент по договорённости. Неизрасходованный рекламный бюджет возвращается, а уже выполненные работы оплачиваются по факту — без штрафов и скрытых условий.',
  },
  {
    question: 'Вы заключаете договор или гарантийное письмо?',
    answer: 'На выбор. Работаем по официальному договору с закрывающими документами либо оформляем гарантийное письмо — оба формата фиксируют обязательства, KPI и порядок отчётности.',
  },
];

export const whyWeGuarantee = [
  {
    icon: 'ri-bar-chart-box-line',
    title: 'Статистика вместо обещаний',
    text: 'За семь лет мы провели сотни кампаний и точно знаем, как растут подписчики и заявки в разных нишах. Прогноз по вашему сообществу даём на основе реальных цифр прошлых проектов, а не «на глаз».',
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Система, а не разовые запуски',
    text: 'Мы не просто «включаем рекламу» — мы выстраиваем систему, где упаковка паблика, контент, таргет и аналитика работают вместе. Поэтому рост получается стабильным и прогнозируемым, а не зависит от удачи.',
  },
  {
    icon: 'ri-test-tube-line',
    title: 'Данные и A/B-тесты',
    text: 'Перед масштабированием проверяем десятки связок и оставляем только те, что дают стабильный прирост подписчиков. Это позволяет заранее понимать, какой результат достижим при вашем бюджете.',
  },
  {
    icon: 'ri-refresh-line',
    title: '96% клиентов продлевают',
    text: 'Главное доказательство — клиенты остаются с нами. Если бы результат был случайным, цифра продлений была бы в разы ниже. Люди продолжают работать, потому что видят стабильный рост.',
  },
  {
    icon: 'ri-file-text-line',
    title: 'KPI фиксируем в договоре',
    text: 'Прописываем измеримые показатели — подписчики, охват и стоимость заявки — и отвечаем за них. Вы заранее понимаете, на какой результат можно рассчитывать в рамках выбранного тарифа.',
  },
  {
    icon: 'ri-team-line',
    title: 'Собственная команда, а не фрилансеры',
    text: 'Над проектом вместе работают таргетолог, аналитик и контент-мейкер. Это исключает «потерю» задач и гарантирует, что каждый этап ведёт специалист своего профиля.',
  },
];

export const processSteps = [
  {
    step: '01',
    title: 'Подготовка сообщества',
    text: 'Создаём привлекательное оформление, дорабатываем упаковку и делаем группу максимально понятной и интересной для потенциальных клиентов.',
  },
  {
    step: '02',
    title: 'Настройка и аккредитация',
    text: 'Если сообщество ещё не запускалось, помогаем выполнить все настройки и пройти аккредитацию, чтобы без проблем запускать рекламу.',
  },
  {
    step: '03',
    title: 'Система привлечения аудитории',
    text: 'Выстраиваем систему так, чтобы каждый новый посетитель сразу понимал, чем вы занимаетесь и какую пользу можете предложить. Это увеличивает число подписчиков и переводит их в клиентов.',
  },
  {
    step: '04',
    title: 'Запуск рекламы',
    text: 'Продвигаем через ВКонтакте, Telegram, Яндекс, Дзен, MAX и другие результативные каналы — от сообществ и сайтов до каналов на стриминговых платформах. Настраиваем кампании на заинтересованную аудиторию — приходят потенциальные клиенты, а не случайные пользователи.',
  },
  {
    step: '05',
    title: 'Аналитика и масштабирование',
    text: 'Отслеживаем показатели, усиливаем самые эффективные решения и постепенно масштабируем продвижение для стабильного результата.',
  },
  {
    step: '06',
    title: 'Постоянный поток клиентов',
    text: 'Наша задача — не просто увеличить число подписчиков, а сформировать постоянный поток клиентов, чтобы сообщество стало полноценным инструментом развития бизнеса.',
  },
];

export const platforms = [
  { icon: 'fa-brands fa-vk', color: '#0077FF', name: 'ВКонтакте', text: 'Главная площадка: сообщества, таргет, охваты и рост подписчиков.' },
  { icon: 'fa-solid fa-bullhorn', color: '#0077FF', name: 'VK Реклама', text: 'Единый кабинет для запуска, тестов и управления кампаниями.' },
  { icon: 'fa-solid fa-bullseye', color: '#00A76F', name: 'myTarget', text: 'Рекламная сеть для расширенного охвата и ретаргетинга.' },
  { icon: 'fa-brands fa-odnoklassniki', color: '#EE8208', name: 'Одноклассники', text: 'Дополнительный охват аудитории 35+ для товаров и услуг.' },
  { icon: 'fa-brands fa-telegram', color: '#2AABEE', name: 'Telegram', text: 'Связка с мессенджером: боты, рассылки и тёплые лиды.' },
  { icon: 'fa-solid fa-spa', color: '#FF6B00', name: 'Дзен', text: 'Контентные публикации для привлечения тёплого трафика.' },
  { icon: 'fa-brands fa-yandex', color: '#FC3F1D', name: 'Яндекс Директ', text: 'Контекстная реклама для захвата уже готового спроса.' },
  { icon: 'fa-solid fa-store', color: '#97CF26', name: 'Avito', text: 'Лиды для локального бизнеса и продажа товаров напрямую.' },
];

export const aboutPlatforms = [
  {
    icon: 'fa-brands fa-vk',
    color: '#0077FF',
    name: 'ВКонтакте',
    reach: '89 млн',
    text: 'Крупнейшая соцсеть России: таргет, сообщества и органические охваты.',
    details: 'Ключевая площадка для сообществ. Ведём сообщества «под ключ», настраиваем таргетированную рекламу, выстраиваем контент-стратегию и растим живой охват, который переводит подписчиков в клиентов.',
    formats: ['Сообщества и паблики', 'Таргетированная реклама', 'Контент и вовлечение'],
  },
  {
    icon: 'fa-brands fa-telegram',
    color: '#2AABEE',
    name: 'Telegram',
    reach: '85 млн',
    text: 'Тёплые лиды через каналы, боты и персональные рассылки.',
    details: 'Используем как связку с ВКонтакте: ведём каналы, запускаем ботов для сбора заявок и прогрева аудитории, настраиваем рассылки, которые доводят тёплых лидов до покупки.',
    formats: ['Каналы и контент', 'Боты и воронки', 'Рассылки и прогрев'],
  },
  {
    icon: 'fa-brands fa-yandex',
    color: '#FC3F1D',
    name: 'Яндекс Директ',
    reach: '60 млн',
    text: 'Контекстная реклама по уже сформированному спросу.',
    details: 'Подключаем контекст, чтобы ловить тех, кто уже ищет ваш продукт. Поиск, РСЯ и ретаргетинг — собираем горячий спрос и ведём его в сообщество или на сайт.',
    formats: ['Поисковая реклама', 'РСЯ (баннеры)', 'Ретаргетинг'],
  },
  {
    icon: 'fa-brands fa-odnoklassniki',
    color: '#EE8208',
    name: 'Одноклассники',
    reach: '36 млн',
    text: 'Аудитория 35+ для товаров, услуг и локального бизнеса.',
    details: 'Платный канал под взрослую платёжеспособную аудиторию. Отлично работает для товаров, услуг и локального бизнеса, где важно дотянуться до людей 35+.',
    formats: ['Таргет на 35+', 'Промо-посты', 'Локальный бизнес'],
  },
  {
    mark: 'Дз',
    color: '#1E1E1E',
    name: 'Дзен',
    reach: '70 млн',
    text: 'Контентные публикации и нативные форматы для тёплого трафика.',
    details: 'Публикуем статьи и нативные материалы, которые формируют доверие к бренду и приносят тёплый трафик. Работает на узнаваемость и долгий эффект, а не только на мгновенные клики.',
    formats: ['Статьи и лонгриды', 'Нативная реклама', 'Узнаваемость бренда'],
  },
  {
    mark: 'A',
    color: '#97CF26',
    name: 'Avito',
    reach: '60 млн',
    text: 'Прямые лиды для продажи товаров и локальных услуг.',
    details: 'Настраиваем объявления так, чтобы получать прямые заявки и звонки. Идеально для продажи товаров и локальных услуг — люди на Avito уже готовы покупать.',
    formats: ['Объявления и лиды', 'Продвижение объявлений', 'Продажа товаров'],
  },
];

export const partnerBonuses = [
  { icon: 'ri-percent-line', title: '10% с каждой оплаты', text: 'Получаете 10% от каждого платежа клиента, которого привели в STRATEGIX.' },
  { icon: 'ri-gift-2-line', title: 'Бонус за привлечение', text: 'Фиксированный бонус после первой оплаты нового клиента.' },
  { icon: 'ri-refresh-line', title: 'Пассивный доход', text: 'Пока клиент продлевает тариф — ваш процент продолжает начисляться.' },
  { icon: 'ri-vip-crown-line', title: 'Скидки для вас', text: 'Персональная скидка на продвижение вашего собственного сообщества.' },
];

export const resultLevers = [
  { icon: 'ri-focus-3-line', title: 'Точный таргетинг', text: 'Собираем портрет аудитории и показываем рекламу тем, кому она действительно нужна.' },
  { icon: 'ri-test-tube-line', title: 'A/B-тесты связок', text: 'Проверяем десятки вариантов и оставляем те, что дают стабильный прирост подписчиков.' },
  { icon: 'ri-article-line', title: 'Контент-стратегия', text: 'Живое сообщество, которое удерживает аудиторию и растёт органически.' },
  { icon: 'ri-refresh-line', title: 'Ретаргетинг', text: 'Догоняем тех, кто уже видел сообщество, и доводим их до подписки.' },
  { icon: 'ri-bar-chart-2-line', title: 'Аналитика воронки', text: 'Анализируем подписчиков и заявки на каждом этапе воронки.' },
  { icon: 'ri-chat-3-line', title: 'Вовлечение аудитории', text: 'Комментарии, конкурсы и активность, которые поднимают охваты паблика.' },
];

export const team = [
  {
    name: 'Ирина Фролова',
    role: 'Главный менеджер',
    focus: 'Ведение проектов, координация команды, согласования с клиентами и контроль сроков.',
    sphere: 'Управление',
  },
  {
    name: 'Оксана Алексеева',
    role: 'СММ-специалист',
    focus: 'Контент-план, рубрикатор и визуальное оформление сообщества.',
    sphere: 'СММ',
  },
  {
    name: 'Валерий Бойко',
    role: 'Маркетолог',
    focus: 'Стратегия продвижения, анализ конкурентов и позиционирование бренда.',
    sphere: 'Маркетинг',
  },
  {
    name: 'Вита Григорьева',
    role: 'Таргетолог',
    focus: 'Настройка и ведение рекламных кампаний, тесты связок и масштабирование результата.',
    sphere: 'Таргет',
  },
  {
    name: 'Виктория Лаврова',
    role: 'СММ-специалист',
    focus: 'Работа с вовлечённостью: комментарии, конкурсы и активность аудитории.',
    sphere: 'СММ',
  },
  {
    name: 'Майя Доркина',
    role: 'Таргетолог',
    focus: 'Аналитика кампаний, отчётность и рост подписчиков.',
    sphere: 'Таргет',
  },
];

export const teamRoles = [
  {
    icon: 'ri-user-star-line',
    title: 'Главный менеджер',
    text: 'Ведёт проект от заявки до результата: координирует команду, согласовывает задачи и держит вас в курсе на каждом этапе.',
  },
  {
    icon: 'ri-chat-smile-2-line',
    title: 'СММ-специалист',
    text: 'Отвечает за контент: план публикаций, рубрикатор, оформление сообщества и вовлечение аудитории — всё, что делает паблик живым.',
  },
  {
    icon: 'ri-megaphone-line',
    title: 'Маркетолог',
    text: 'Выстраивает стратегию продвижения: анализирует конкурентов, определяет позиционирование и выбирает каналы, которые дадут результат.',
  },
  {
    icon: 'ri-radar-line',
    title: 'Таргетолог',
    text: 'Настраивает и ведёт рекламные кампании, тестирует связки и следит за ростом подписчиков — за стабильный результат отвечает именно он.',
  },
];

export const teamValues = [
  {
    icon: 'ri-links-line',
    title: 'Работаем в связке',
    text: 'Стратег, СММ, маркетолог и таргетолог ведут проект вместе, а не по отдельности. Результат складывается из слаженной работы, а не случайных удач.',
  },
  {
    icon: 'ri-focus-3-line',
    title: 'Каждый — за свой участок',
    text: 'Вы всегда знаете, кто за что отвечает. Никакой «размытой» ответственности: у каждого специалиста чёткая зона, за которую он отвечает результатом.',
  },
  {
    icon: 'ri-time-line',
    title: 'Всегда на связи',
    text: 'Отвечаем оперативно и без «пропавших» менеджеров. На всех этапах держим вас в курсе — от старта кампании до еженедельной отчётности.',
  },
  {
    icon: 'ri-eye-line',
    title: 'Прозрачная работа',
    text: 'Не прячем процессы за красивыми словами: вы видите, что делает команда, какие кампании запущены и какой результат они дают.',
  },
];

export const pricingPlans = [
  {
    name: 'Минимальный',
    tagline: 'Акционный тариф для первых кампаний',
    price: 'от 9 000 ₽',
    popular: false,
  },
  {
    name: 'Средний',
    tagline: 'Оптимальный объём для стабильного роста',
    price: '14 000 – 16 000 ₽',
    popular: true,
  },
  {
    name: 'Максимальный',
    tagline: 'Расширенное продвижение для крупных задач',
    price: '19 000 – 24 000 ₽',
    popular: false,
  },
];

